// extracted by mini-css-extract-plugin
module.exports = {"avatarStyle":"styles_avatarStyle__2Tmrq"};